// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductOverviewPriceTable-module-list","title":"ProductOverviewPriceTable-module-title","row":"ProductOverviewPriceTable-module-row"};